/**
 * ChatbotsPlace: All-in-One AI Sidebar (ChatGPT, Claude & Gemini)
 *
 * Declares four web-accessible resources on `<all_urls>` with `use_dynamic_url: false`:
 * `logo/logo_128.png` plus three build-hashed `assets/*.js` bundles. The hashed bundle
 * names rotate every release, so only the stable `logo/logo_128.png` is a durable
 * signal — it is served at a fixed URL to any page and loads through `probeImage` with
 * no CORS grant.
 *
 * Manifest verified against version 2.6.1.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cbapcdnkcgiajboppakkhjmdolbkinge';

export const chatbotsPlace: ExtensionDefinition = {
  id: ID,
  name: 'ChatbotsPlace: All-in-One AI Sidebar (ChatGPT, Claude & Gemini)',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 600_000,
  notes:
    'Four WAR on <all_urls>, three of them build-hashed .js bundles that rotate per ' +
    'release. Only the stable logo/logo_128.png is probed; it loads without a CORS grant.',
  signals: [
    {
      id: 'war-logo-128',
      kind: 'web-accessible-resource',
      description:
        'Load logo/logo_128.png via <img> — the only non-hashed WAR path, exposed to ' +
        'every origin; needs no CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'logo/logo_128.png'),
    },
  ],
};
